import authConstants from '../constants';
import isStringSet from 'utilities/is/isStringSet';

const initialState = {
    qrCode: null,
    codeSending: false,
    needsCode: true,
    emailAvailable: false,
    smsAvailable: false,
    authCodeDialogOpen: false,
    qrCodeDialogOpen: false,
    qrScannedDialogOpen: false,
    authenticating: false,
    loggedIn: false,
    codeSent: false,
    errorMessage: null,
    requesting: false,
    redirect: false
};

export function auth(state = initialState, action) {
    switch (action.type) {
        case authConstants.QR_CODE_DIALOG_OPEN:
            return {
                ...state,
                qrCodeDialogOpen: true,
                qrScannedDialogOpen: false
            };
        case authConstants.QR_CODE_DIALOG_CLOSED:
            return {
                ...state,
                qrCodeDialogOpen: false,
                qrScannedDialogOpen: false
            };
        case authConstants.QR_SCANNER_DIALOG_OPEN:
            return {
                ...state,
                qrCodeDialogOpen: false,
                qrScannedDialogOpen: true
            };
        case authConstants.QR_SCANNER_DIALOG_CLOSED:
            return {
                ...state,
                qrCodeDialogOpen: false,
                qrScannedDialogOpen: false
            };
        
        case authConstants.AUTH_CODE_DIALOG_OPEN:
            return {
                ...state,
                authCodeDialogOpen: isStringSet(state.qrCode)
            };
        case authConstants.AUTH_CODE_DIALOG_CLOSED:
            return {
                ...state,
                authCodeDialogOpen: false,
                qrDialogOpen: false,
                qrScannedDialogOpen: false,
                loggedIn: false
            };
        case authConstants.INITIALISE_REQUESTED:
            return {
                ...state,
                qrCode: action.qrCode
            };
        case authConstants.INITIALISE_SUCCESS:
            return {
                ...state,
                emailAvailable: action.emailAvailable,
                smsAvailable: action.smsAvailable,
                qrCodeDialogOpen: false,
                qrScannedDialogOpen: false,

                // trigger the auth code dialog to open
                authCodeDialogOpen: isStringSet(state.qrCode)
            };
        case authConstants.INITIALISE_FAILURE:
            return {
                ...state,
                errorMessage: action.failureReason
            };
        case authConstants.SEND_CODE_REQUESTED:
            return {
                ...state,
                codeSending: true,
                codeSent: false
            };
        case authConstants.SEND_CODE_FAILURE:
            return {
                ...state,
                codeSent: false,
                codeSending: false,
                errorMessage: action.failureReason
            };
        case authConstants.SEND_CODE_SUCCESS:
            return {
                ...state,
                codeSent: true,
                codeSending: false,
                errorMessage: null
            };
        case authConstants.CONTINUE_REQUESTED:
            return {
                ...state,
                code: action.code,
                loggedIn: false,
                authenticating: true
            };
        case authConstants.CONTINUE_FAILURE:
            return {
                ...state,
                code: "",
                authenticating: false,
                errorMessage: action.failureReason
            };
        case authConstants.CONTINUE_SUCCESS:
            return {
                ...state,
                needsCode: false,
                redirect: true,
                loggedIn: true,
                loginDateTime: new Date().toISOString(),
                qrCodeDialogOpen: false,
                authCodeDialogOpen: false,
                authenticating: false,
            };
        case authConstants.SIGN_OUT_SUCCESS:
            return initialState;
        case authConstants.LOGGED_IN_SUCCESS:
            return {
                ...state,
                needsCode: !action.isLoggedIn,
                qrCode: action.qrCode,
                loggedIn: action.isLoggedIn
            }
        case authConstants.LOGGED_IN_FAILURE:
            return {
                ...state,
                loggedIn: false
            }
        default:
            return state;
    }
}
